/**
 * OrbDocCoreConceptsEntitiesARDocScreenView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait OrbDocCoreConceptsEntitiesARDocScreen
 */

import { useOrbDocCoreConceptsEntitiesARDocScreenLogic } from '@/hooks/traits/useOrbDocCoreConceptsEntitiesARDocScreenLogic';
import type { OrbDocCoreConceptsEntitiesARDocScreenConfig } from '@/hooks/traits/useOrbDocCoreConceptsEntitiesARDocScreenLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { OrbDocCoreConceptsEntitiesARDocView as OrbDocCoreConceptsEntitiesARDocViewEntity } from '@app/shared';
import { OrbDocCoreConceptsEntitiesARDocBodyView } from '@/components/traits/OrbDocCoreConceptsEntitiesARDocBodyView';
import { OrbDocCoreConceptsEntitiesARDocFooterView } from '@/components/traits/OrbDocCoreConceptsEntitiesARDocFooterView';
import { OrbDocCoreConceptsEntitiesARDocHeaderView } from '@/components/traits/OrbDocCoreConceptsEntitiesARDocHeaderView';
import { Stack } from '@almadar/ui/components';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';

interface OrbDocCoreConceptsEntitiesARDocScreenViewProps {
  config?: Partial<OrbDocCoreConceptsEntitiesARDocScreenConfig>;
}

export function OrbDocCoreConceptsEntitiesARDocScreenView({ config: propsConfig }: OrbDocCoreConceptsEntitiesARDocScreenViewProps) {
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useOrbDocCoreConceptsEntitiesARDocScreenLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['OrbDocCoreConceptsEntitiesARDocView'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="OrbDocCoreConceptsEntitiesAR" trait="OrbDocCoreConceptsEntitiesARDocScreen">
      <UISlotComponent slot="main" pattern={slotWriter['main'] === 'INIT' ? "stack" : "clear"} sourceTrait="OrbDocCoreConceptsEntitiesARDocScreen">{slotWriter['main'] === 'INIT' ? (<Stack direction="vertical" gap="none"><OrbDocCoreConceptsEntitiesARDocHeaderView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><OrbDocCoreConceptsEntitiesARDocBodyView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><OrbDocCoreConceptsEntitiesARDocFooterView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Stack>) : null}</UISlotComponent>
    </TraitScopeProvider>
  );
}

export default OrbDocCoreConceptsEntitiesARDocScreenView;
